import { Input, InputRef } from 'antd';
import React, { useEffect, useMemo, useRef } from 'react';
import { $Formutil, connect, FormItemComponentProps } from 'react-antd-formutil';
import FormItem from 'components/FormItem';
import classlist from 'utils/classlist';

import './style.scss';

export interface OnetimeCodeProps extends Omit<FormItemComponentProps, 'children' | 'name'> {
    $formutil: $Formutil;
    length?: number; // 需要展示方块的个数(默认6位)
    className?: string;
    autoFocus?: boolean; // 支持自动聚焦(默认支持)
    masked?: boolean; // 是否隐藏输入的值（默认隐藏）
    variant?: 'box' | 'line'; // 边框 or 线条
    size?: 'middle' | 'large';
    name: NonNullable<FormItemComponentProps['name']>;
}

const DEFAULT_LENGTH = 6;

const OnetimeCode: React.FC<OnetimeCodeProps> = ({
    length = DEFAULT_LENGTH,
    className,
    autoFocus = true,
    masked = true,
    variant = 'box',
    name,
    $formutil,
    $onFieldChange,
    size = 'middle',
    checker,
    errorLevel
}) => {
    const value = $formutil.$params[name];
    const inputRef = useRef<InputRef | null>(null);

    const focus = () => {
        inputRef.current?.focus();
    };

    useEffect(() => {
        if (autoFocus) {
            focus();
        }
    }, [autoFocus]);

    const inputs = useMemo(() => {
        const inputs: JSX.Element[] = [];

        for (let i = 0; i < length; i++) {
            inputs.push(
                <span
                    key={i}
                    className={classlist('onetime-code-square', {
                        active: masked && value?.[i],
                        current: value ? value.length === i : i === 0,
                        [`onetime-code-${variant}`]: true,
                        [`onetime-code-${size}`]: true
                    })}>
                    {masked ? '' : value?.[i]}
                </span>
            );
        }

        return inputs;
    }, [length, masked, variant, value, size]);

    return (
        <div className={classlist('onetime-code-root', className)} onClick={focus}>
            <div className="onetime-code-input-box">{inputs}</div>
            <FormItem
                className="onetime-code-input-form"
                name={name}
                $onFieldChange={$onFieldChange}
                checker={checker}
                errorLevel={errorLevel}
                $parser={value => value?.slice(0, length)}>
                <Input
                    className="onetime-code-input"
                    ref={node => {
                        if (node) {
                            inputRef.current = node;

                            if (autoFocus) {
                                requestAnimationFrame(() => {
                                    focus();
                                });
                            }
                        }
                    }}
                    type={masked ? 'password' : 'text'}
                    autoFocus={autoFocus}
                    autoComplete={masked ? 'new-password' : 'one-time-code'}
                    onBlur={autoFocus ? focus : undefined}
                />
            </FormItem>
        </div>
    );
};

export default connect(OnetimeCode);
